import React from 'react';
import Box from '@mui/material/Box';
import ProgressCard from './ProgressCard';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

const t = (key: string, options?) => translate('reports', key, options);

type OverallProgressCardProps = {
  progress: any;
  isStudentProgress?: boolean;
};

const OverallProgressCard: React.FC<OverallProgressCardProps> = ({
  progress,
  isStudentProgress,
}) => {
  return (
    <Box display="flex" gap={remCalc(24)}>
      {isStudentProgress ? (
        <ProgressCard
          title={t('readTheBook')}
          highlightedText={progress?.bookReadCount ?? 0}
          label={t('times')}
          helpText={t('readTheBookHelp')}
        />
      ) : (
        <ProgressCard
          title={t('numberOfBooksRead')}
          highlightedText={progress?.bookReadStudentCount ?? 0}
          label={`${t('of')} ${26}`}
          helpText={t('numberOfBooksReadHelp')}
        />
      )}

      <ProgressCard
        title={t('noOfActivitiesCompleted')}
        highlightedText={progress?.activityCompletedCount ?? 0}
        label={`${t('of')} ${progress?.activityTotalCount ?? 0}`}
        helpText={t('noOfActivitiesCompletedHelp')}
      />
      <ProgressCard
        title={t('noOfActivitiesSkipped')}
        highlightedText={progress?.activitySkippedCount ?? 0}
        label={t('activities')}
        helpText={t('noOfActivitiesSkippedHelp')}
      />
    </Box>
  );
};

export default OverallProgressCard;
